import styled from "styled-components";
import { Button } from "antd";
import colors from "css/colors";

export const GreenButton = styled(Button)`
  font-size: 16px;
  line-height: 22px;
  text-transform: uppercase;
  border-color: ${colors.GREEN};
  background-color: ${colors.GREEN};
  border-radius: 6px;

  &:hover,
  &:focus {
    border-color: ${colors.GREEN_LIGHT};
    background-color: ${colors.GREEN_LIGHT};
  }
`;

export const WhiteButton = styled(Button)`
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
  border-color: ${colors.BLUE};
  color: ${colors.BLUE};
  background-color: ${colors.WHITE};
  border-radius: 6px;

  &:hover {
    border-color: ${colors.BLUE};
    color: ${colors.WHITE};
    background-color: ${colors.BLUE};
  }

  &:disabled {
    border-color: ${colors.GREY_ULTRA_LIGHT};
    background-color: ${colors.WHITE};
  }
`;
